"use client"
import { faMoon, faSun } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '@heroui/react'
import { useTheme } from 'next-themes'
import { useEffect, useState } from 'react'
import { useTranslations } from 'next-intl'

export default function ThemeSelect({ fullSize = false }: { fullSize?: boolean }) {
  const [mounted, setMounted] = useState(false)
  const { theme, setTheme } = useTheme()

  useEffect(() => {
    setMounted(true)
  }, [])
  const t = useTranslations("Navbar")

  if (!mounted) return null

  return (
    <Button variant='light' isIconOnly={!fullSize} onPress={() => setTheme(theme === "light" ? "dark" : "light")}
      className="flex items-center justify-start gap-3 w-full p-3 rounded-lg">
      <FontAwesomeIcon icon={theme === "light" ? faSun : faMoon} className="text-2xl" />
      {fullSize && <span>{t(theme === "light" ? "lightMode" : "darkMode")}</span>}
    </Button>
  )
}